import { useNextEffect } from 'common/hooks/use-next-effect'
import { useFormContext } from 'react-hook-form'

import { FIELD_NAMES } from '../validation'

export const useIsFullImpairment = () => {
  const { watch, setValue } = useFormContext()
  const impairedAmount = watch(FIELD_NAMES.impaired_amount, 0)
  const impairedAmountMaximum = watch(FIELD_NAMES.impaired_amount_maximum, 0)

  const isFullImpairment = impairedAmount === impairedAmountMaximum

  useNextEffect(() => {
    setValue(FIELD_NAMES.is_partial_impairment, !isFullImpairment)
  }, [isFullImpairment])

  return isFullImpairment
}
